import { jsx } from "react/jsx-runtime";
import classnames from "classnames";
import { rootClass } from "../constant.js";
import "./index.css";
function AvatarContainer(props) {
    const { shape = 'circle', size = 'medium', className, style, children, onClick } = props;
    return /*#__PURE__*/ jsx("span", {
        className: classnames(rootClass, shape, `${rootClass}__${size}`, className),
        style: style,
        onClick: onClick,
        children: children
    });
}
export { AvatarContainer as default };
